<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="snackbars.errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericInfoSnackbar" color="primary">

      {{ snackbars.genericInfoText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericInfoSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericErrorSnackbar" color="error">

      {{ snackbars.genericErrorText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericErrorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-dialog v-model="dialogs.registrationCompleteDialog" persistent max-width="650">

      <v-card>

        <v-card-title class="text-h5 mb-2 word-break"><strong>Registration Complete</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p><v-icon>mdi-check-circle</v-icon> Your receipt has been sent to <strong>{{ $store.state.user.email }}</strong>.</p>

          <hr class="mt-6 mb-6" />

          <div class="mb-4" style="text-align: center"><v-btn @click="returnToDashboard" color="primary">close and return to dashboard</v-btn></div>

        </v-card-text>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmRemoveFromCartDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Remove from Cart</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Are you sure you want to remove from cart?</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="removeFromCart" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmRemoveFromCartDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.paymentFailedDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 mb-2 word-break"><strong>Payment Failed</strong></v-card-title>

        <v-card-text class="text-body-1">

          <v-icon>mdi-alert-circle-outline</v-icon> Your payment failed.  Please try again.

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <div class="mb-4" style="text-align: center"><v-btn @click="dialogs.paymentFailedDialog = false" color="primary">ok</v-btn></div>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.paymentDialog" persistent max-width="800">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Checkout</strong></v-card-title>

        <v-card-text class="mt-2">

          <p>Enter credit card details and click "Checkout" at the bottom of the screen.</p>

          <iframe :src="safeCheckoutUrl" ref="iframe" style="width: 750px; height: 600px;"></iframe>

        </v-card-text>

      </v-card>

    </v-dialog>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-card elevation="0">

      <v-card-title class="text-h5 ml-2 mr-2"><strong>Cart</strong></v-card-title>

      <v-card-text>

        <p class="ml-2" v-if="cartItems.length == 0">Your cart is empty.</p>

        <ul class="mt-2" v-if="cartItems.length > 0">

          <v-alert icon="mdi-information-outline" class="mb-4">

            To complete the registration, click Pay Now.  You will be prompted to enter your credit card details and a receipt will be automatically sent to <strong>{{ $store.state.user.email }}</strong>.

          </v-alert>

          <li v-for="(obj, index) in cartItems" :key="index">

            <div class="mb-4"><h3>{{ obj.addressInfo }}</h3></div>

            <div>Registration Period: <strong>{{ obj.startDate }}</strong> to <strong>{{ obj.endDate }}</strong></div>

            <div>Type of Burn: {{ obj.typeOfBurn }}</div>

            <div>Fee: ${{ obj.fee }}</div>

            <div>Fee Type: {{ obj.feeType }}</div>

            <br />

            <div><a href="#" @click="confirmRemoveFromCart(obj.id)">Remove</a></div>

            <hr v-if="index != cartItems.length - 1" class="mb-6 mt-6" />

          </li>

        </ul>

        <div style="text-align: right; font-weight: bold;" class="mt-10 mb-1">

          <span style="font-size: 1.2em;" class="mr-2">Total: ${{ Number(getTotal().toFixed(2)) }}</span>

        </div>

        <hr class="mt-4" v-if="cartItems.length != 0" />

        <div class="mt-6 mb-1 ml-1" v-if="cartItems.length != 0">

          <h4>OBER Declaration</h4>

          <p class="mt-4">I declare that the information provided is accurate to the best of my knowledge, and have read, understand and will comply with the requirements of <a href="https://metrovancouver.org/boards/Bylaws/MVRD_Bylaw_1355.pdf#search=bylaw%201355" target="_blank">Metro Vancouver Regional District Open Burning Emission Regulation Bylaw No. 1355, 2022</a>.</p>

          <v-alert icon="mdi-information-outline">

            Every day you plan to burn, and before you burn, you must call <strong>604-436-6777</strong> for the burning conditions that day.

          </v-alert>

          <p>

            <v-checkbox v-model="isCertified" class="mt-6" label="I have read, understood and agree with the above statements." :error-messages="isCertifiedErrors"></v-checkbox>

          </p>

        </div>

        <v-layout>

          <v-btn color="primary" class="mt-4 mb-4" @click="navigateToDashboard"><v-icon left>mdi-arrow-left-circle</v-icon>return to dashboard</v-btn>

          <v-spacer></v-spacer>

          <v-btn color="primary" class="mt-4 mb-4" v-if="cartItems.length > 0" @click="pay"><v-icon left>mdi-credit-card</v-icon>pay now</v-btn>

        </v-layout>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";
import {required} from "vuelidate/lib/validators";

function validateMustBeTrue(value: any, data: any) {

  if (value) return true;

  return false;

}

export default Vue.extend({

  validations: {

    isCertified: {

      validateMustBeTrue

    }

  },

  mounted() {

    // Listen for messages from the iframe
    window.addEventListener('message', (event) => {

      let iframeResponse;

      try {

        iframeResponse = JSON.parse(event.data);

      }
      catch (exception) {

        return;

      }

      if (iframeResponse.handler == 'payment_receipt' && iframeResponse.ticket == this.ticket && iframeResponse.response_code == '001') {

        this.dialogs.paymentDialog = false;

        this.loading = true;

        setTimeout(async () => {

          try {

            let obj = await axios.get('api/Checkout/ProcessTransaction?ticket=' + this.ticket);

            this.loading = false;

            if (obj.data == '%%PAYMENT_DECLINED%%') {

              // the payment was declined

              this.dialogs.paymentFailedDialog = true;

              return;

            }
            else if (obj.data == '%%SUCCESS%%') {

              // the payment was successful

              this.dialogs.registrationCompleteDialog = true;

            }
            else
            {
              // something happened during the payment process

              this.snackbars.genericErrorText = 'There was an issue with processing the payment.  Please contact Metro Vancouver for further assistance.';

              this.snackbars.genericErrorSnackbar = true;
            }

          } catch (error) {

            if (this.$route.path != '/Login') this.$router.push('/Login');

          }

        })

      } else if (iframeResponse.handler == 'cancel_transaction' && iframeResponse.ticket == this.ticket && iframeResponse.response_code == '001') {

        this.dialogs.paymentDialog = false;

      }

    });

  },

  methods: {

    navigateToDashboard() {

      if (this.$route.path != '/Form') this.$router.push('/Form');

    },

    clearSnackbars(){

      this.snackbars.errorSnackbar = false;

      this.snackbars.genericInfoSnackbar = false;

      this.snackbars.genericErrorSnackbar = false;

    },

    returnToDashboard() {

      if (this.$route.path != '/Form') this.$router.push('/Form');

    },

    completeCheckout() {

      this.dialogs.paymentDialog = false;

    },

    pay() {

      this.$v.$touch();

      if (this.$v.$error) {

        this.snackbars.errorSnackbar = true;

      } else {

        this.clearSnackbars();

        this.loading = true;

        setTimeout(async () => {

          try {

            let order = await axios.get('api/Order/CreateOrder?amount=' + this.getTotal());

            if (order.data == '%%PAST_REGISTRATION_EXISTS%%')
            {
              this.loading = false;

              this.snackbars.genericErrorText = 'Please remove any registrations that have a start date in the past.';

              this.snackbars.genericErrorSnackbar = true;

              return;
            }

            var orderNumber = order.data.substring(order.data.indexOf('-') + 1);

            this.orderNumber = orderNumber;

            let ticket = await axios.get('api/Checkout/GetTicket?orderNumber=' + this.orderNumber);

            this.loading = false;

            if (ticket.data == '%%FAILED%%') {

              this.snackbars.genericErrorText = 'There was an issue acquiring the ticket number.  Please contact the system administrator.';

              this.snackbars.genericErrorSnackbar = true;

              return;

            }

            this.ticket = ticket.data;

            this.checkoutUrl = process.env.VUE_APP_CHECKOUT_URL + '?ticket=' + this.ticket + '&orderNumber=' + this.orderNumber;

            this.dialogs.paymentDialog = true;

          } catch (error) {

            if (this.$route.path != '/Login') this.$router.push('/Login');

          }

        }, 200)

      }

    },

    getTotal() {

      let total = 0

      for (let item of this.cartItems) {

        total += (item as any).fee;

      }

      return total
    },

    confirmRemoveFromCart(id:number) {

      this.cartItemId = id;

      this.clearSnackbars();

      this.dialogs.confirmRemoveFromCartDialog = true;

    },

    async removeFromCart() {

      this.dialogs.confirmRemoveFromCartDialog = false;

      this.loading = true;

      setTimeout(async () => {

        try {

          let obj = await axios.get('api/Cart/RemoveFromCart?id=' + this.cartItemId);

          let query = await axios.get('api/Cart/GetCartItems');

          this.loading = false;

          this.cartItems = query.data;

          this.snackbars.genericInfoText = 'The registration has been removed from the cart.';

          this.snackbars.genericInfoSnackbar = true;

        } catch (error) {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 200)

    }

  },

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

        let query = await axios.get('api/Cart/GetCartItems');

        this.loading = false;

        this.cartItems = query.data;

      } catch (error) {

        if (this.$route.path != '/Login') this.$router.push('/Login');

      }

    }, 200)

  },

  computed: {

    safeCheckoutUrl(): string {

      if (this.checkoutUrl == null || this.checkoutUrl == '') return '';

      const url = new URL(this.checkoutUrl);

      const allowedHosts = process.env.VUE_APP_ALLOWED_IFRAME_HOSTS.split(',').map((h:string) => h.trim());

      if (allowedHosts.includes(url.hostname)) return url.toString();

      return 'about:blank';

    },

    isCertifiedErrors() {

      if (!this.$v.$dirty) return [];

      if (this.$v.isCertified && !this.$v.isCertified.validateMustBeTrue) {

        return ['You must click the box above to continue.'];

      }

      return [];

    }

  },

  data () {

    return {

      isCertified: false,

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

      },

      orderNumber: '',

      ticket: '',

      checkoutUrl: '',

      loading: false,

      cartItems: [],

      cartItemId: null as number | null,

      dialogs: {

        registrationCompleteDialog: false,

        confirmRemoveFromCartDialog: false,

        paymentDialog: false,

        paymentFailedDialog: false

      }
    }

  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

</style>
